/* eslint-disable @typescript-eslint/no-explicit-any */
import { IAppAction } from "../appAction";
import { homeActions } from "./home-action";
import { getDefaultHomeState, IHomeState } from "./home-state";

const handlers = {
  [homeActions.FETCH_HOME]: (
    state: IHomeState
  ): IHomeState => {
    return { ...state, loading: true };
  },

  [homeActions.FETCH_HOME_SUCCESS]: (
    state: IHomeState,
    payload: any
  ): IHomeState => {
    return { ...state, loading: false, homeGifs: payload };
  },

  [homeActions.FETCH_HOME_ERROR]: (
    state: IHomeState,
    error: Error
  ): IHomeState => {
    // eslint-disable-next-line
    console.warn("Failed to load feeds", error);
    return { ...state, errorMessage: error.message, loading: false };
  },
};

const homeReducer = (
  state: IHomeState = getDefaultHomeState(),
  action: IAppAction
) => {
  return Object.prototype.hasOwnProperty.call(handlers, action.type) ?
    handlers[action.type](state, action.payload || action.error) : state;
};

export default homeReducer;
